import { render, staticRenderFns } from "./ProfilesHead.vue?vue&type=template&id=50ffb936&scoped=true"
import script from "./ProfilesHead.vue?vue&type=script&lang=js"
export * from "./ProfilesHead.vue?vue&type=script&lang=js"
import style0 from "./ProfilesHead.vue?vue&type=style&index=0&id=50ffb936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ffb936",
  null
  
)

export default component.exports